export const SET_LOGS = 'SET_LOGS'
export const CLEAR_LOGS = 'CLEAR_LOGS';
export const LOGS_INIT_STATE = null;